import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import socket from '../../socket';


const Main = (props) => {
 

  const roomRef = useRef();
  const userRef = useRef();
  const [err, setErr] = useState(false);
  const [errMsg, setErrMsg] = useState('');

  useEffect(() => {
    socket.on('FE-error-user-exist', ({ error }) => {
      if (!error) {
        const roomName = roomRef.current.value;
        const userName = userRef.current.value;

        sessionStorage.setItem('user', userName);
        props.history.push(`/room/${roomName}`);
      } else {
        setErr(error);
        setErrMsg('User name already exist');
      }
    });
  }, [props.history]);

  function clickJoin() {
    const roomName = roomRef.current.value;
    const userName = userRef.current.value;

    if (!roomName || !userName) {
      setErr(true);
      setErrMsg('Введите данные');
    } else {
      socket.emit('BE-check-user', { roomId: roomName, userName });
    }
  }

  return (
    
    <MainContainer>
      <DescriptionContainer>
        <DescriptionText>
        Внутренний видеочат Nethammer <br/><br/>

Видеочат Nethammer — это решение для эффективной и удобной коммуникации внутри компании. 
        </DescriptionText>
      </DescriptionContainer>
      <FormContainer>
       
        <Row>
          
          <Input  placeholder="  Название комнаты" type="text" id="roomName" ref={roomRef} />
        </Row>
        <Row>
          
          <Input placeholder="  Ваше имя" type="text" id="userName" ref={userRef} />
        </Row>
        <JoinButton onClick={clickJoin}>Присоединиться</JoinButton>
        {err ? <Error>{errMsg}</Error> : null}
      </FormContainer>
    </MainContainer>
  );
};

const MainContainer = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: rgb(31, 41, 55);
  padding: 20px;
  border-radius: 20px;
   /* Страница будет заполнять весь экран */
  align-content: flex-start;
   flex-wrap: wrap;
   text-align: center;
`;



const DescriptionContainer = styled.div`
  flex: 1;
  padding-right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
`;

const DescriptionText = styled.p`
  font-size: 17px;
  text-align: left;
  line-height: 1.5;
  width: 70%;
  margin: 0;
`;

const FormContainer = styled.div`
  text-align: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
   background-color: rgb(17 ,24, 39) ;
  border-radius: 15px;
  padding: 10px;
  width: 5px;
  
  align-content:center ;
   flex-wrap: wrap;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 15px;
  line-height: 35px;
`;

const Label = styled.label`
  font-size: 16px;
  color: #fff;
`;

const Input = styled.input`
  width: 200px;
  height: 35px;
  margin-left: 15px;
  padding: 10px;
  outline: none;
  border: none;
  border-radius: 10px;
  scale: 1.2;
   
`;

const Error = styled.div`
  margin-top: 10px;
  font-size: 18px;
  color: #e85a71;
`;

const JoinButton = styled.button`
  
  margin-top: 35px;
  outline: none;
  border: none;
  border-radius: 15px;
  color:rgb(255, 255, 255);
  background-color: #4166d5;
  font-size: 17px;
 
  padding: 10px;
  margin-right: 35px;

  :hover {
    background-color: rgb(23, 84, 252);
    cursor: pointer;
  }
`;

export default Main;
